import type { LoginForm, SignupForm } from "@web/auth/schemas";
import type { LoginRequest, SignupRequest } from "@/domain/model/Auth";

import type { StartRegistrationCheckoutCommand } from "@/domain/model/Registration";
import type { RegistrationForm } from "./auth/Registration";
import { LEGAL_DOCUMENTS } from "@/domain/model/LegalDocuments";

export function mapFormToSignupRequest(form: SignupForm): SignupRequest {
  return {
    accountName: form.accountName.trim(),
    email: form.email.trim().toLowerCase(),
    password: form.password,
  };
}

export function mapFormToLoginRequest(form: LoginForm): LoginRequest {
  return {
    email: form.email.trim().toLowerCase(),
    password: form.password,
  };
}

export function mapRegistrationToSignupRequest(
  form: RegistrationForm,
): SignupRequest {
  return {
    accountName: form.accountName.trim(),
    email: form.email.trim().toLowerCase(),
    password: form.password,
  };
}

export function mapRegistrationFormToStartCheckoutCommand(
  form: RegistrationForm,
): StartRegistrationCheckoutCommand {
  return {
    accountName: form.accountName.trim(),
    ownerFullName: form.ownerFullName.trim(),
    email: form.email.trim().toLowerCase(),
    password: form.password,

    billingCompanyName: form.billingCompanyName.trim(),
    billingStreet: form.billingStreet.trim(),
    billingPostalCode: form.billingPostalCode.trim(),
    billingCity: form.billingCity.trim(),
    billingCountry: form.billingCountry,
    vatId: form.vatId?.trim() || undefined,

    seatCount: form.seatCount,
    preferredPaymentMethod: form.preferredPaymentMethod,

    acceptedTermsVersion: LEGAL_DOCUMENTS.terms.version,
    acceptedPrivacyVersion: LEGAL_DOCUMENTS.privacy.version,
    acceptedAvvVersion: LEGAL_DOCUMENTS.avv.version,
    acceptedUserTermsVersion: LEGAL_DOCUMENTS.userTerms.version
  };
}
